import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";

export const MuiDatePicker = (props: any) => {
    const {
        name,
        label,
        value,
        onChange,
        fullWidth,
        disablePast,
        disableFuture,
        disabled,
        error,
        ...others
    } = props;

    const convertToDefEventPara = (name: any, value: any) => ({
        target: {
            name,
            value,
        },
    });

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                label={label}
                value={dayjs(value, "DD/MM/YYYY")}
                disabled={disabled}
                format="DD/MM/YYYY"
                disablePast={disablePast}
                disableFuture={disableFuture}
                slotProps={{
                    textField: {
                        size: "small",
                        fullWidth,
                        error: !!error,
                        helperText: error,
                    },
                }}
                onChange={(date) => onChange(convertToDefEventPara(name, date))}
            />
        </LocalizationProvider>
    );
};
